import { render, staticRenderFns } from "./ConfiguratorContainer.vue?vue&type=template&id=66c3d984&scoped=true&"
import script from "./ConfiguratorContainer.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorContainer.vue?vue&type=style&index=0&id=66c3d984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3d984",
  null
  
)

export default component.exports